import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">AID Worship</h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            <div className="flex gap-4">
              <a
                href="http://www.youtube.com/@AIDWorship"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-zinc-800 rounded-full hover:bg-amber-500 hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-youtube-line text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/aid_worship/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-zinc-800 rounded-full hover:bg-amber-500 hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about-us')}
                  className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer"
                >
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('training')}
                  className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer"
                >
                  {t('nav.training')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('give')}
                  className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer"
                >
                  {t('nav.give')}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.connect')}</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer"
                >
                  {t('nav.contact')}
                </button>
              </li>
              <li>
                <a
                  href="mailto:aidworshipseoul@gmail.com"
                  className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer"
                >
                  aidworshipseoul@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-8 text-center text-gray-400 text-sm">
          <p>
            &copy; {new Date().getFullYear()} AID Worship. {t('footer.rights')}.{' '}
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-amber-500 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}